import i18n from 'vue-i18n'

import { BaseNodeModelData } from '../../BaseNode/BaseNodeDataModel'
import { BaseNodeModel } from '../../BaseNode/BaseNodeModel'
import { CustomNode, CustomNodeComponent } from '../../index'
import ErrorNodeSidebar from '../ui/ErrorNodeSidebar.vue'
import ErrorSampleNode from '../ui/ErrorSampleNode.vue'

export default class ErrorNodeBuilder extends CustomNodeComponent {
  menuSection = ''
  sidebarComponent = ErrorNodeSidebar

  constructor(i18n: i18n) {
    super(ErrorSampleNode, ErrorNode, 'ERROR', i18n)
  }

  getBaseNodeModel: any
}

export class ErrorNode extends CustomNode {
  data: BaseNodeModelData

  constructor(name: 'ERROR', model: BaseNodeModel) {
    super(name, model)

    this.data = model.data
  }

}
